<template>
     <div class="draggable-fixed">
        <slot></slot>
    </div>    
</template>
<script>
import Draggable from "./Draggable.js";

export default {
    
    mounted(){
        let base = this.$el.querySelector(this.element);
        let draggable = new Draggable(base, {dragTargets: this.dragTargets});
        draggable.init();

        if (this.destroyOnTouchScreen) {
            document.addEventListener('touchstart', () => {draggable.destroy()}, {once: true});
        }
    },
    props: {
        dragTargets: {
            type: Array,        
        },
        element: {
            type: String
        },
        destroyOnTouchScreen: {
            type: Boolean,
            default: false
        }
    }

}
</script>